export class ReportViewProperties {
    public static readonly WIDTH_TO_HEIGHT_VIEW_RATIO = 1.778;
}
  
